export enum ACCOUNT_ACCESS_MODE {
  FULL_ACCESS = 'full_access',
  BILLING_ONLY = 'billing_only',
}
export enum ACCOUNT_ACCESS_REASON {
  ACTIVE = 'active',
  IN_RECOVERY = 'in_recovery',
  SUBSCRIPTION_CANCELLED = 'subscription_cancelled',
  SUBSCRIPTION_MISSING = 'subscription_missing',
  BILLING_SUSPENDED_NONPAYMENT = 'billing_suspended_nonpayment',
  SUBSCRIPTION_PAUSED = 'subscription_paused',
  ACCOUNT_DISABLED_ADMIN = 'account_disabled_admin',
  SHOPIFY_BILLING_ISSUE = 'shopify_billing_issue',
}
